/* ui/game/StopButton.svelte generated by Svelte v3.23.2 */
import {
	SvelteComponent,
	detach,
	element,
	init,
	insert,
	listen,
	noop,
	safe_not_equal,
	set_custom_element_data
} from "svelte/internal";

import { APP } from "../store";

function create_fragment(ctx) {
	let sl_button;
	let mounted;
	let dispose;

	return {
		c() {
			sl_button = element("sl-button");

			sl_button.innerHTML = `<sl-icon slot="prefix" name="stop"></sl-icon>
  Pause
`;

			set_custom_element_data(sl_button, "type", "danger");
			set_custom_element_data(sl_button, "size", "small");
		},
		m(target, anchor) {
			insert(target, sl_button, anchor);

			if (!mounted) {
				dispose = listen(sl_button, "click", /*handleClick*/ ctx[0]);
				mounted = true;
			}
		},
		p: noop,
		i: noop,
		o: noop,
		d(detaching) {
			if (detaching) detach(sl_button);
			mounted = false;
			dispose();
		}
	};
}

function instance($$self) {
	function handleClick() {
		APP.ticker.stop();
	}

	return [handleClick];
}

class StopButton extends SvelteComponent {
	constructor(options) {
		super();
		init(this, options, instance, create_fragment, safe_not_equal, {});
	}
}

export default StopButton;